var render = function render(_c,_vm){return _c('div',{class:[ 'form-message', { '-positive': _vm.props.positive } ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }